
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Home, Upload, Database } from 'lucide-react';

const NavigationSection = () => {
  const location = useLocation();
  const isFootballPage = location.pathname === '/football';

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex gap-4">
        <Link to="/">
          <Button variant="outline">
            <Home className="mr-2 h-4 w-4" />
            Home
          </Button>
        </Link>
        {!isFootballPage && (
          <Link to="/football">
            <Button variant="outline">
              <Database className="mr-2 h-4 w-4" />
              States
            </Button>
          </Link>
        )}
        {isFootballPage && (
          <Link to="/upload">
            <Button variant="outline">
              <Upload className="mr-2 h-4 w-4" />
              Upload
            </Button>
          </Link>
        )}
        <Link to="/countryorder">
          <Button variant="outline">
            <Database className="mr-2 h-4 w-4" />
            Country Order
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default NavigationSection;
